import React from "react";
import Modal from "components/Modal/Modal";
import { ModalProps } from "../Modal/Modal";
import {
  ShipFacilityModalFragment,
  ShipDiningAreaModalFragment
} from "types/graphql-types";
import ContentWithSlideshow from "./ContentWithSlideshow";
import { snakeCase } from "src/utils/strings";
import { isPresent } from "src/utils/checks";
import { ModalBody } from "@silversea-ssc/ui-components-react";

export interface ShipFacilityModalProps extends ModalProps {
  type: "facility";
  content: ShipFacilityModalFragment;
}

export interface ShipDiningAreaModalProps extends ModalProps {
  type: "diningArea";
  content: ShipDiningAreaModalFragment;
}

const ShipFacilityModal: React.FC<
  ShipFacilityModalProps | ShipDiningAreaModalProps
> = ({ modal, type, content }) => {
  const title = content?.card?.title?.localized || "";
  const images = content.images?.filter(isPresent);

  return (
    <Modal
      title={title}
      modal={modal}
      size="big"
      data-content-name={`modal_${snakeCase(content?.card?.title?.en || "")}`}
    >
      <ModalBody variant="wide">
        {type == "facility" && (
          <ContentWithSlideshow
            title={title}
            images={images}
            description={content.description?.localized}
          />
        )}
        {type == "diningArea" && (
          <ContentWithSlideshow
            title={title}
            images={images}
            description={content.description?.localized}
          />
        )}
      </ModalBody>
    </Modal>
  );
};

export default ShipFacilityModal;
